import { useQuery } from "@tanstack/react-query";
import { client } from "@/lib/hono";

export const useGetPublicAvatarLooks = (
    groupId: string | null | undefined
) => {
    return useQuery({
        queryKey: ["avatars", "public", "looks", groupId],
        enabled: !!groupId,
        queryFn: async () => {
            const response =
                await client.api.avatars.heygen.avatars.public.looks.$get({
                    query: { groupId: groupId! },
                });
            if (!response.ok) throw new Error("Failed to load public looks");
            const json = await response.json();
            return json.data.looks;
        },
        staleTime: 1000 * 60 * 60,
    });
};
